/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { DetailAccordionCard, DetailName, Identification, labels } from '@umati/dashboard-common';
import ImageAndTimeline from 'components/detail/common/ImageAndTimeline';
import Header from 'components/header/header';
import { DInfoRects } from 'components/_lib/Details';
import React from 'react';
import { Accordion } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFair, getMachine, getMachinesByParent } from 'redux/selectors';
import FrontendURLs from 'utilities/FrontendURLs';
import MachineHandling from 'utilities/MachineHandling';

function FallbackDetailMachine(props: any) {
  const machine = props.data;
  // const machine = dummyData;

  const identification = machine?.Identification || props.machine?.Data;
  const productInstanceUri =
    machine?.Identification?.ProductInstanceUri || MachineHandling.getProductInstanceUri(props.machine);
  const position = props.fairTag ? props.machine?.Positions?.[props.fairTag] : null;
  const detailRectProps = [
    { label: labels.hall, value: position?.hall },
    { label: labels.booth, value: position?.booth },
  ];
  const model = identification?.Model?.text || 'Undefined';
  const anchor = model?.replace(/\s+/g, '') || '';
  const headerDetail = {
    text: model,
    link: FrontendURLs.getMachine(
      { TypeDefinition: props.typeId, MachineId: props.machineId, Encoding: props.Encoding },
      props.fairTag,
    ),
    anchor,
  };

  return (
    <div>
      <Header {...props} fairTag={props.fairTag || 'all'} detail={headerDetail} listType="machines" />
      <div className="view-machine-detail">
        <div className="hero">
          <div className="container-max">
            <DetailName isOnline={props?.machine?.Online} name={productInstanceUri} model={model} />
            {position && <DInfoRects infos={detailRectProps} />}
          </div>
        </div>
        <div className="container-max">
          <ImageAndTimeline
            imagePath={machine?.ImagePath}
            machineId={props.machineId}
            machineType={props.typeId}
            defaultImagePathClassifier={machine?.Identification?.DeviceClass}
          />
          <div className="row justify-content-end">
            <div className="col-12 offset-lg-2 col-lg-9">
              <Accordion defaultActiveKey="0" className="mb-4">
                <DetailAccordionCard eventKey="0" title="Identification" isExpanded={true}>
                  <Identification {...identification} />
                </DetailAccordionCard>
                <DetailAccordionCard eventKey="1" title="Errors" isExpanded={true}>
                  <p>{props.error.message}. Probably the machine does not follow the companion specification.</p>
                </DetailAccordionCard>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps: any): any => {
  return {
    fair: getFair(state, ownProps.fairTag),
    machine: getMachine(state, ownProps.machineId),
    subMachines: getMachinesByParent(state, ownProps.machineId),
  };
};

const FallbackDetail = connect(mapStateToProps)(FallbackDetailMachine);
export default FallbackDetail;
